import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Check if we have valid Supabase credentials
const hasValidCredentials = 
  supabaseUrl && 
  supabaseAnonKey &&
  supabaseUrl !== 'your_supabase_url_here' && 
  supabaseAnonKey !== 'your_supabase_anon_key_here' &&
  supabaseUrl.startsWith('http');

if (!hasValidCredentials) {
  console.warn('⚠️  Supabase credentials not configured. Running in demo mode.');
}

// Create a mock Supabase client for demo mode
const createMockSupabaseClient = (): any => ({
  from: () => ({
    insert: () => ({ select: () => ({ single: () => Promise.resolve({ data: null, error: new Error('Demo mode') }) }) }),
    select: () => ({ order: () => Promise.resolve({ data: [], error: new Error('Demo mode') }) }),
    update: () => ({ eq: () => Promise.resolve({ error: new Error('Demo mode') }) }),
  }),
  storage: {
    from: () => ({
      upload: () => Promise.resolve({ data: null, error: new Error('Demo mode') }),
      getPublicUrl: () => ({ data: { publicUrl: 'https://via.placeholder.com/400x300' } }),
    }),
  },
});

export const supabase: SupabaseClient = hasValidCredentials 
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: false, // No session persistence - admin must log in each time
        autoRefreshToken: false,
      },
    })
  : createMockSupabaseClient();

export const STORAGE_BUCKET = 'id-cards';

export const SUPABASE_CONFIGURED = hasValidCredentials;